import React, { useEffect, useRef, useState } from "react";
import './CustomerPolicyDetailView.scss';
import { Button, Column, Icon, Row, Panel as Panel1 } from "./../../../components";
import { Tabs, Tab } from "react-bootstrap";
import { Panel } from 'primereact/panel';
import CustomerPolicyDetailViewService from "./CustomerPolicyDetailViewService";
import { toast } from 'react-toastify';
import Logger from '../../../shared/services/Logger';
import * as constant from '../../../shared/util/constant';
import CustomerPolicyCoverage from '../customer-policy-detail-view/customer-policy-coverage/CustomerPolicyCoverage';
import { CustomerPolicyDetailLabels as cstPolicyDetailLabel, POLICY_NUMBER } from '../../../shared/util/label';
import CustomerPolicyEndorsements from "./customer-policy-endorsements/CustomerPolicyEndorsements";
import CustomerPolicyUnderwriting from "./customer-policy-underwriting/CustomerPolicyUnderwriting";
import CustomerPolicyTransactions from "./customer-policy-transactions/CustomerPolicyTransactions";
import { PolicyTransactionsReadDto } from "../../model/PolicyTransactionsReadDto";;
import { PolicyLOBReadDto } from "../../model/PolicyLOBReadDto";
import { PolicyLocationReadDto } from "../../model/PolicyLocationReadDto";
import CustomerPolicyLocations from "./customer-policy-locations/CustomerPolicyLocations";
import { PolicyCoverageReadDto } from "../../model/PolicyCoverageReadDto";
import { PolicyEndorsementsReadDto } from "../../model/PolicyEndorsementsReadDto";
import { PolicyUnderwritingReadDto } from "../../model/PolicyUnderwritingReadDto";
import { PolicyAdditionalInterestDto } from "../../model/PolicyAdditionalInterestDto";
import CustomerPolicyAdditionalInterests from "./customer-policy-additional-interests/CustomerPolicyAdditionalInterests";
import { PolicyDtoRead } from "../../model/PolicyDtoRead";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PolicyFloodCoverageDto } from "../../model/PolicyFloodCoverageDto";
import CustomerPolicyFloodCoverage from "./customer-policy-coverage/CustomerPolicyFloodCoverage";
import CustomerPolicyFloodUnderwriting from "./customer-policy-underwriting/CustomerPolicyFloodUnderwriting";

export interface ICustomerPolicyDetailView {
    policySummary: PolicyDtoRead
};


const CustomerPolicyDetailView: React.FunctionComponent<ICustomerPolicyDetailView> = (props) => {

    const dispatch = useDispatch();

    const policySummary = props.policySummary;

    const [transactionDetails, setTransactionDetails] = useState<PolicyTransactionsReadDto[]>([]);

    const [selectedTransactionSeqNum, setSelectedTransactionSeqNum] = useState();

    const [lobsDetails, setLOBsDetails] = useState<PolicyLOBReadDto[]>([]);

    const [selectedLOB, setSelectedLOB] = useState("");

    const [selectedLOBCode, setSelectedLOBCode] = useState("");

    const [floodCoveragesDetails, setFloodCoveragesDetails] = useState<PolicyFloodCoverageDto[]>([]);
    
    const [floodUnderwritingDetails, setFloodUnderwritingDetails] = useState(null);

    const [locationsDetails, setLocationsDetails] = useState<PolicyLocationReadDto[]>([]);

    const [selectedLocation, setSelectedLocation] = useState("");

    const [coveragesDetails, setCoveragesDetails] = useState<PolicyCoverageReadDto[]>([]);

    const [endorsementssDetails, setEndorsementsDetails] = useState<PolicyEndorsementsReadDto[]>([]);

    const [underwritingDetails, setUnderwritingDetails] = useState<PolicyUnderwritingReadDto>(null);

    const [additionalInterestsDetails, setAdditionalInterestsDetails] = useState<PolicyAdditionalInterestDto[]>([]);

    const panelRefs = {
        Transactions: useRef<HTMLDivElement>(null),
        LOBs_Locations: useRef<HTMLDivElement>(null),
        BasicCoverage: useRef<HTMLDivElement>(null),
        Endorsements: useRef<HTMLDivElement>(null),
        Underwriting: useRef<HTMLDivElement>(null),
        AdditionalInterests: useRef<HTMLDivElement>(null),
        FloodCoverage: useRef<HTMLDivElement>(null),
    };

    const history = useHistory();
    
    const customerPolicyDetailViewService = new CustomerPolicyDetailViewService();

    // const scrollToSection = (ref: React.RefObject<HTMLDivElement>, container: HTMLElement) => {
    //     if (ref.current) {
    //         console.log("Target Scroll Top:", ref.current.offsetTop);
    //         // container.scrollTop();
    //         container.scrollTo({
    //             top: 1000,
    //             behavior: "smooth",
    //         });
    //         console.log("Updated Scroll Top:", container.scrollTop);
    //     }
    // };

    const initTransactions = async () => {
        try {
            let response = await customerPolicyDetailViewService.getTransactionsDetails(policySummary.id);
            setTransactionDetails(response);
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const initLOBs = async () => {
        try {
            if (selectedTransactionSeqNum) {
                let response = await customerPolicyDetailViewService.getLOBs(policySummary.id, selectedTransactionSeqNum);
                setLOBsDetails(response);
                if (response.length > 0) {
                    setSelectedLOB(response[0].id)
                    setSelectedLOBCode(response[0].lobCode)
                }
                else {
                    setSelectedLOB('')
                    setSelectedLOBCode('')
                }
            }
            else {
                setLOBsDetails([])
                setSelectedLOB('')
                setSelectedLOBCode('')
            }
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const initLocations = async () => {
        try {
            if (selectedTransactionSeqNum && selectedLOB) {
                let response = await customerPolicyDetailViewService.getLocations(policySummary.id, selectedLOB, selectedTransactionSeqNum);
                setLocationsDetails(response);
            }
            else {
                setLocationsDetails([])
            }
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const initCoveragesAndEndorsements = async () => {
        try {
            if (selectedTransactionSeqNum && selectedLOB) {
                let response = await customerPolicyDetailViewService.getCoveragesAndEndorsements(policySummary.id, selectedLOB, selectedTransactionSeqNum);
                    setCoveragesDetails(response.coverages.filter(coverage =>
                        coverage.attachTypeValue === 'Location'
                            ? coverage.attachId === selectedLocation
                            : true // if not Location, include all
                    ));
                    setEndorsementsDetails(response.endorsements.filter(endorsement =>
                        endorsement.attachTypeValue === 'Location'
                            ? endorsement.attachId === selectedLocation
                            : true));
                
                if(selectedLOBCode === constant.CUSTOMER_POLICY_LOBCode.FLOOD)
                {
                    const polEventId=(transactionDetails.filter(x => x.seqNum === selectedTransactionSeqNum)[0].polEventId);
                    let response = await customerPolicyDetailViewService.getFloodCoverages(policySummary.id, selectedLOB, polEventId);
                    setFloodCoveragesDetails(response.coverages);
                    // Fetch flood underwriting details
                    let floodUnderwritingResponse = await customerPolicyDetailViewService.getPolicyFloodUnderwritingByLocation(policySummary.id, selectedLOB, selectedLocation, selectedTransactionSeqNum);
                    setFloodUnderwritingDetails(floodUnderwritingResponse);
                }
            }
            else {
                setCoveragesDetails([]);
                setEndorsementsDetails([]);
                setFloodCoveragesDetails([]);
            }
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const initUnderwriting = async () => {
        try {
            if (selectedTransactionSeqNum && selectedLOB && selectedLocation) {
                let response = await customerPolicyDetailViewService.getUnderwriting(policySummary.id, selectedLOB, selectedLocation, selectedTransactionSeqNum);
                setUnderwritingDetails(response)
            }
            else {
                setUnderwritingDetails(null)
            }
        }
        catch (error) {
            if (error && error.status === 404) {
                setUnderwritingDetails(null)
            } else {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
            }
        }
    };

    const initAdditionalInterests = async () => {
        try {
            if (selectedTransactionSeqNum && selectedLOB) {
                let response = await customerPolicyDetailViewService.getAdditionalInterests(policySummary.id, selectedLOB, selectedTransactionSeqNum);
                setAdditionalInterestsDetails(response);
            }
            else {
                setAdditionalInterestsDetails([])
            }
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    };

    const handleTransactionSelection = (columnValue: any) => {
        setSelectedTransactionSeqNum(columnValue)
    };

    const handleLocationSelection = (columnValue: any) => {
        setSelectedLocation(columnValue)
    };

    const handleTranEffDateClick = (policyTransactionClicked: PolicyTransactionsReadDto) => {
        history.push(`/customer-view/policy-details/${policySummary.custId}/${policySummary.id}/${policyTransactionClicked.polEventId}`, { policyTransactionClicked, policyId: policySummary.id });
    };

    useEffect(() => {
        initTransactions();
    }, []);

    useEffect(() => {
        initLOBs();
    }, [selectedTransactionSeqNum]);

    useEffect(() => {
        initLocations();
        initAdditionalInterests();
    }, [selectedLOB,selectedTransactionSeqNum]);

    useEffect(() => {
        initCoveragesAndEndorsements();
        initUnderwriting();
    }, [selectedLOB,selectedLocation,selectedTransactionSeqNum]);

    const containerRef = useRef<HTMLDivElement>(null); // Scrollable container reference

    return (
        <div ref={containerRef}>
            <Row>
                <Column>
                    <div>
                        <section
                            ref={panelRefs.Transactions}
                            id={`${constant.CustomerPolicyDetailLinks.TRANSACTIONS}-${policySummary.policyNumber}`}
                            className="custom-panel"
                        >
                            <Panel toggleable collapsed={false} className="custom-panel-content">
                                <CustomerPolicyTransactions
                                    policyTransactions={transactionDetails}
                                    onSelectTransaction={handleTransactionSelection}
                                    onTranEffDateClick={handleTranEffDateClick}
                                />
                            </Panel>
                        </section>
                        {selectedTransactionSeqNum && (
                            <>
                                <nav className="section-links">
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            panelRefs.LOBs_Locations.current?.scrollIntoView({ behavior: "smooth", block: "center" })
                                        }}
                                    >
                                        {cstPolicyDetailLabel.LOB}
                                    </a>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            panelRefs.BasicCoverage.current?.scrollIntoView({ behavior: "smooth", block: "center" })
                                        }}
                                    >
                                        {cstPolicyDetailLabel.BASIC}
                                    </a>
                                    <a
                                        href={"#"}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            panelRefs.Endorsements.current?.scrollIntoView({ behavior: "smooth", block: "center" })
                                        }}
                                    >
                                        {cstPolicyDetailLabel.ENDORSEMENTS}
                                    </a>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            panelRefs.Underwriting.current?.scrollIntoView({ behavior: "smooth", block: "center" })
                                        }}
                                    >
                                        {cstPolicyDetailLabel.UNDERWRITING}
                                    </a>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            panelRefs.AdditionalInterests.current?.scrollIntoView({ behavior: "smooth", block: "center" })
                                        }}
                                    >
                                        {cstPolicyDetailLabel.ADDITIONAL_INTERESTS}
                                    </a>

                                </nav>
                                <section
                                    ref={panelRefs.LOBs_Locations}
                                    id={`${constant.CustomerPolicyDetailLinks.LOBS_LOCATIONS}-${policySummary.policyNumber}`}
                                    className="custom-panel"
                                >
                                    <Panel toggleable collapsed={false} className="custom-panel-content">
                                        {/* Show LOB tabs here */}
                                        <div className="custom-tabs-wrapper">
                                            <div className="custom-tab-list d-flex">
                                                {lobsDetails.map((lobDetails) => (
                                                    <div
                                                        key={lobDetails.id}
                                                        className={`custom-tab px-3 py-2 me-2 ${lobDetails.id === selectedLOB ? 'active' : ''}`}
                                                        onClick={() => {
                                                            setSelectedLOB(lobDetails.id);
                                                            setSelectedLOBCode(lobDetails.lobCode);
                                                        }}
                                                    >
                                                        {lobDetails.lobCode}
                                                    </div>
                                                ))}
                                            </div>
                                            <CustomerPolicyLocations policyLocations={locationsDetails} onSelectLocation={handleLocationSelection} />
                                        </div>

                                    </Panel>
                                </section>
                                 {selectedLOBCode === constant.CUSTOMER_POLICY_LOBCode.FLOOD ? (
                                    <section
                                        ref={panelRefs.FloodCoverage}
                                        id={`${constant.CustomerPolicyDetailLinks.FLOOD_COVERAGE}-${policySummary.policyNumber}`}
                                        className="custom-panel"
                                    >
                                        <Panel toggleable collapsed={false} className="custom-panel-content">
                                            <CustomerPolicyFloodCoverage policyFloodCoverage={floodCoveragesDetails} />
                                        </Panel>
                                    </section>
                                ) : (
                                <section
                                    ref={panelRefs.BasicCoverage}
                                    id={`${constant.CustomerPolicyDetailLinks.BASIC_COVERAGE}-${policySummary.policyNumber}`}
                                    className="custom-panel"
                                >
                                    <Panel toggleable collapsed={false} className="custom-panel-content">
                                        <CustomerPolicyCoverage policyCoverage={coveragesDetails} lobCode={selectedLOBCode} />
                                    </Panel>                                   
                                </section>
                                 )}
                                <section
                                    ref={panelRefs.Endorsements}
                                    id={`${constant.CustomerPolicyDetailLinks.ENDORSEMENTS}-${policySummary.policyNumber}`}
                                    className="custom-panel"
                                >
                                    <Panel header={cstPolicyDetailLabel.ENDORSEMENTS} toggleable collapsed={false} className="custom-panel-content">
                                        <CustomerPolicyEndorsements policyEndorsements={endorsementssDetails} lobCode={selectedLOBCode} />
                                    </Panel>
                                </section>
                                <section
                                    ref={panelRefs.Underwriting}
                                    id={`${constant.CustomerPolicyDetailLinks.UNDERWRITING}-${policySummary.policyNumber}`}
                                    className="custom-panel"
                                >
                                    <Panel header={cstPolicyDetailLabel.UNDERWRITING} toggleable collapsed={false}>
                                        {selectedLOBCode === constant.CUSTOMER_POLICY_LOBCode.FLOOD ? (
                                            floodUnderwritingDetails && selectedLocation ? (
                                                <CustomerPolicyFloodUnderwriting floodUnderwriting={floodUnderwritingDetails} />
                                            ) : (
                                                <div className="no-underwriting-message">{constant.PolicySummaryErrorMessages.NO_UNDERWRITING_FOUND}</div>
                                            )
                                        ) : (
                                            selectedLocation ?
                                                <CustomerPolicyUnderwriting policyUnderwriting={underwritingDetails} />
                                                :
                                                <div className="no-underwriting-message">{constant.PolicySummaryErrorMessages.NO_UNDERWRITING_FOUND}</div>
                                        )}
                                    </Panel>
                                </section>
                                <section
                                    ref={panelRefs.AdditionalInterests}
                                    id={`${constant.CustomerPolicyDetailLinks.ADDITIONAL_INTERESTS}-${policySummary.policyNumber}`}
                                    className="custom-panel"
                                >
                                    <Panel toggleable collapsed={false} className="custom-panel-content">
                                        <CustomerPolicyAdditionalInterests policyAdditionalInterests={additionalInterestsDetails} />
                                    </Panel>
                                </section>
                            </>
                        )}
                    </div>
                </Column>
            </Row>
        </div>
    );

};

export default CustomerPolicyDetailView;